import { BqTag } from '~/components/ui/misc/bqTag/BqTag';

export function LivenessTagCellAg(props: { value: boolean | null }) {
  switch (props.value) {
    case null:
      return '-';
    case false:
      return <BqTag color="danger" value="Dead" />;
    case true:
      return <BqTag color="success" value="Live" />;
  }
}
